export var HAS_VISITED_CATEGORY_SEARCH_PAGES = 'HAS_VISITED_CATEGORY_SEARCH_PAGES';
